(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_86ae48f"] && !Shopify.designMode) return;
  try {
    // Portrait two is display:none below 750px. Keep its video inert there
  // so an invisible autoplay video does not consume the mobile connection.
  // Mount the original Shopify markup unchanged once desktop is visible.
  if (!customElements.get('slowform-desktop-video')) {
    customElements.define('slowform-desktop-video', class extends HTMLElement {
      connectedCallback() {
        this.desktopQuery ??= window.matchMedia('(min-width: 750px)');
        this.desktopQuery.addEventListener('change', this.mountVideo);
        this.mountVideo();
      }

      disconnectedCallback() {
        this.desktopQuery?.removeEventListener('change', this.mountVideo);
      }

      mountVideo = () => {
        if (!this.isConnected || !this.desktopQuery.matches) return;
        const template = this.querySelector('template');
        if (template) template.replaceWith(template.content.cloneNode(true));
        this.desktopQuery.removeEventListener('change', this.mountVideo);
      };
    });
  }
  } catch(e) { console.error(e); }
})();

})();
